<section class="login-content" [class.global-message]="hasGlobalMessages()">

  <header class="animated fadeInDown login-header">
    <button class="btn btn-sm btn-white btn-back" type="button" (click)="goBack()">
      <span class="material-symbols-outlined">
        chevron_left
      </span> GO BACK
    </button>
  </header>

  <section class="content">

    <div class="login">

      <div class="login-card">

        <img class="login__logo" src="/assets/images/logo.webp" alt="Carlton Farms logo" [routerLink]="['/shop']">

        <h3 class="title-text h3-bold mb-0">
          Welcome to Our New Site!
        </h3>

        <!-- Temporal welcome message -->

        <section class="border-bottom pb-3 mt-3">
          <h4 class="title-text h4-semibold mb-0">
            Please Reset Your Password
          </h4>

          <p class="recovery-message text-center">
            To keep your account secure and ensure a smooth transition, we kindly ask that you reset your password
            before
            continuing.
          </p>

          <section class="d-grid col-12 col-md-6 col-lg-6 m-auto">
            <button type="button" class="btn btn-outline-primary" [routerLink]="['/account-recovery/check-email']">
              Reset My Password
            </button>
          </section>
        </section>

        <!-- End Temporal Welcome Message -->

        <form class="d-flex flex-column mt-3 login-form" (ngSubmit)="onSubmit($event)">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Email address</mat-label>
            <input type="email" #emailCtrl="ngModel" [ngModel]="email()" (ngModelChange)="onEmailChange($event)"
              matInput name="emailInput" required />
          </mat-form-field>
          <mat-error>
            @if ((emailCtrl.hasError('required') || emailCtrl.hasError('email')) && (emailCtrl.dirty ||
            emailCtrl.touched)) {
            {{ emailCtrl.hasError('required') ? 'Email is required' : 'Invalid email format' }}
            }
          </mat-error>

          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Password</mat-label>
            <input type="password" #passwordCtrl="ngModel" [ngModel]="password()"
              (ngModelChange)="onPasswordChange($event)" matInput name="passwordInput" required
              type="{{ hidePassword ? 'password' : 'text' }}" />
            <button mat-button matSuffix type="button" (click)="hidePassword = !hidePassword" class="eye-icon-button"
              [attr.aria-label]="'Toggle ' + (hidePassword ? 'visibility' : 'hide')">
              @if (hidePassword) {
              <span class="material-symbols-outlined text-muted">
                visibility
              </span>
              } @else {
              <span class="material-symbols-outlined text-muted">
                visibility_off
              </span>
              }
            </button>
          </mat-form-field>
          <mat-error>
            <small class="form-text">
              <p>Your password must have:</p>
              <div class="password-hint">
                @for (condition of passwordConditions; track $index) {
                <div class="hint-list">
                  <span class="hint-icon" [class]="condition.key() ? 'text-success' : 'text-danger'">
                    <i class="fas" [class.fa-circle-check]="condition.key()"
                      [class.fa-circle-xmark]="!condition.key()"></i>
                  </span>
                  {{ condition.text }}
                </div>
                }
              </div>
            </small>
          </mat-error>

          <div class="col d-flex justify-content-end">
            <a href="#!" class="forget-link" [routerLink]="['/account-recovery/check-email']">
              Forgot your password?
            </a>
          </div>

          <button type="submit" class="btn btn-primary mt-4 mb-2" [disabled]="authService.isLoadingLogin()">
            @if (authService.isLoadingLogin()) {
            <i class="fas fa-spinner fa-spin"></i>
            }
            Log in
          </button>

          <div class="row mb-4 align-items-center">
            <div class="col">
              <mat-checkbox [(ngModel)]="hasExtendedSession" name="hasExtendedSession" class="remember-label">
                Keep me logged in!
              </mat-checkbox>
            </div>
          </div>

        </form>

        <footer class="d-flex gap-2 flex-wrap mt-3 justify-content-center">
          <span class="h6-regular">Don't have an account yet?</span>
          <span class="h6-regular cursor-pointer link-color" (click)="goToSignUp()">Sign up now</span>
        </footer>

      </div>

    </div>

  </section>

  <footer class="login-content__footer">
    <div class="header">
      <h1 class="title">
        FROM FIELD TO TABLE
      </h1>
      <img src="/assets/images/logo-footer.webp"
        alt="Carlton Farms logo featuring silhouettes of a cow, pig, and chicken on a red background. Text reads: 'Carlton Farms, Rockmart, GA, Est. 1919, Pasture-Raised Meat, Milk & Eggs.">
    </div>
    <h3 class="subtitle">
      Fresh products, raised in a natural way and with the care of generations.
    </h3>
  </footer>

</section>